import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { CarePlanTemplatesApi } from '../../../apis/CarePlanTemplatesApi/CarePlanTemplatesApi.ts';

export function useGetCarePlanTemplatesForInvitation(
  facilityId?: number,
  therapeuticIndicationId?: number,
) {
  const enabled =
    !!facilityId &&
    facilityId > 0 &&
    !!therapeuticIndicationId &&
    therapeuticIndicationId > 0;

  return useQuery({
    queryKey: [
      QueryKeys.carePlanTemplates,
      'forInvitation',
      facilityId ?? 0,
      therapeuticIndicationId ?? 0,
    ],
    queryFn: () =>
      CarePlanTemplatesApi.getForInvitation(
        facilityId!,
        therapeuticIndicationId!,
      ),
    enabled,
  });
}
